import { NavParams, Events, Content } from 'ionic-angular'
import { Component, NgZone, ViewChild } from '@angular/core';
import { Map } from '../itinerary/map';
import { Minutes } from '../../pipes/minutes';
import { DatetimeToDate } from '../../pipes/datetime';
import { Stops } from '../../pipes/stops';

@Component({
  templateUrl: 'build/pages/itinerary/detail.html',
  directives: [Map],
  pipes: [Minutes, DatetimeToDate, Stops]
})
export class DetailPage {
  private parallax: any
  private journey: any
  private start: any
  private end: any
  
  @ViewChild(Content) content: Content;

  constructor(params: NavParams, private events: Events, private zone: NgZone) {
    this.journey = params.get('journey');
    this.start = params.get('start');
    this.end = params.get('end');
  }

  ngAfterViewInit() {
    this.events.publish('carpostal:detail:draw', this.journey, this.start, this.end)
    
    // Paralax !
    this.parallax = e => {
      let scrollTop = e.target.scrollTop;
      let scrollFactor = scrollTop / 2;

      this.zone.run(() => {
        map.style['-webkit-transform'] = 'translate3d(0, +' + scrollFactor + 'px, 0)';
      });
    };

    let scroll = (<HTMLElement>document.querySelector('ion-content.detail')).children[0];
    let map = (<HTMLElement>document.querySelector('.detail-map'));

    scroll.addEventListener('scroll', this.parallax);
  }

  zoom(section) {
    if (section.geojson) {
      this.content.scrollToTop(1000);
    }
    
    this.events.publish('carpostal:detail:zoom', section);
  }

  ionViewWillUnload() {
    // Lets remove the listener
    let scroll = (<HTMLElement>document.querySelector('ion-content.detail')).children[0];
    scroll.removeEventListener('scroll', this.parallax);
  }
}
